export default __webpack_public_path__ + "media/images/logo-symbol-icon-b5fb2e897398d339479815aa76470845.svg";